var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.177 4.878a2.144 2.144 0 0 0-1.51-1.52C14.338 3 9 3 9 3s-5.337 0-6.668.359A2.144 2.144 0 0 0 .823 4.878C.467 6.218.467 9.012.467 9.012s0 2.795.356 4.135a2.113 2.113 0 0 0 1.51 1.494C3.662 15 9 15 9 15s5.337 0 6.668-.359a2.113 2.113 0 0 0 1.509-1.494c.356-1.34.356-4.135.356-4.135s0-2.795-.356-4.134ZM7.255 11.55V6.475l4.46 2.537-4.46 2.538Z",
    fill: "currentColor"
  })));
};
export default SvgYoutubeIcon;